import React from "react";

import suekLogo from "../../assets/images/suek.svg";
import classes from "./Logo.module.scss";

interface IProps {
  height: number;
}

const Logo: React.FC<IProps> = ({ height }) => (
  <div className={classes.Logo}>
    <img src={suekLogo} alt="SUEK" height={height} />
  </div>
);

export default Logo;
